export default __webpack_public_path__ + "static/media/GrayCircle.dfd4e040.svg";